import axios from '@/utils/request.js'

export const getDefaultAddress = (userId) => { // 用户查询默认地址
  return axios.get(`/goods/bGlmAddress/getDefaultAddress/${userId}`)
}

export const getAllAddress = (userId) => { // 用户查询所有地址
  return axios.get(`/goods/gas/address/getAllAddress/${userId}`)
}

export const getOneAddress = (addressId) => { // 查询地址明细
  return axios.get(`/goods/gas/address/getOneAddress/${addressId}`)
}

export const addAddress = (params) => { // 新增地址
  return axios.post('/goods/gas/address/addAddress', params)
}

export const updateAddress = (params) => { // 修改地址
  return axios.post('/goods/gas/address/updateAddress', params)
}

export const delAddress = (addressId) => { // 删除地址
  return axios.get(`/goods/gas/address/delAddress/${addressId}`)
}
